import { Route } from 'src/routes/Route'
import { CatalogSubroute } from 'src/catalog/routes/CatalogRoute'

export const AddCardToGiftRoute = Route({
  path: '/add-card-to-gift',
  init: (subroute?: CatalogSubroute) => ({ subroute }),
  fromPath: () => ({}),
  subroute: CatalogSubroute,
})

export type AddCardToGiftRoute = Route<typeof AddCardToGiftRoute>
